export default "__VITE_ASSET__DoDbE3q3__"